// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ClockArrowDown,
    ClockArrowLeft,
    ClockArrowRight,
    ClockArrowUp,
    ClockCheck,
    ClockFading,
    ClockPlus,
    ClosedCaption,
    Cloud,
    CloudAlert,
    CloudBackup,
    CloudCheck,
    CloudCog,
    CloudDownload,
    CloudDrizzle,
    CloudFog,
    CloudHail,
    CloudLightning,
    CloudMoon,
    CloudMoonRain,
    CloudOff,
    CloudRain,
    CloudRainWind,
    CloudSnow,
    CloudSun,
    CloudSunRain,
    CloudSync,
    CloudUpload,
    Cloudy,
    Clover,
    Club,
    Code,
    CodeXml,
    Coffee,
    Cog,
    Coins,
    Columns2,
    Columns3,
    Columns3Cog,
    Columns4,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "clock-arrow-down" through "columns-4", inclusive. */
const shard: Record<string, LucideIcon> = {
    "clock-arrow-down": ClockArrowDown,
    "clock-arrow-left": ClockArrowLeft,
    "clock-arrow-right": ClockArrowRight,
    "clock-arrow-up": ClockArrowUp,
    "clock-check": ClockCheck,
    "clock-fading": ClockFading,
    "clock-plus": ClockPlus,
    "closed-caption": ClosedCaption,
    cloud: Cloud,
    "cloud-alert": CloudAlert,
    "cloud-backup": CloudBackup,
    "cloud-check": CloudCheck,
    "cloud-cog": CloudCog,
    "cloud-download": CloudDownload,
    "cloud-drizzle": CloudDrizzle,
    "cloud-fog": CloudFog,
    "cloud-hail": CloudHail,
    "cloud-lightning": CloudLightning,
    "cloud-moon": CloudMoon,
    "cloud-moon-rain": CloudMoonRain,
    "cloud-off": CloudOff,
    "cloud-rain": CloudRain,
    "cloud-rain-wind": CloudRainWind,
    "cloud-snow": CloudSnow,
    "cloud-sun": CloudSun,
    "cloud-sun-rain": CloudSunRain,
    "cloud-sync": CloudSync,
    "cloud-upload": CloudUpload,
    cloudy: Cloudy,
    clover: Clover,
    club: Club,
    code: Code,
    "code-xml": CodeXml,
    coffee: Coffee,
    cog: Cog,
    coins: Coins,
    "columns-2": Columns2,
    "columns-3": Columns3,
    "columns-3-cog": Columns3Cog,
    "columns-4": Columns4,
};

export default shard;
